export default "__VITE_ASSET__8FVOz5P7__"